import { render, staticRenderFns } from "./I18nGroupFrame.vue?vue&type=template&id=1b761358&scoped=true&"
import script from "./I18nGroupFrame.vue?vue&type=script&lang=js&"
export * from "./I18nGroupFrame.vue?vue&type=script&lang=js&"
import style0 from "./I18nGroupFrame.vue?vue&type=style&index=0&id=1b761358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b761358",
  null
  
)

export default component.exports